import axios from 'axios'
import React, { useEffect, useState } from 'react'
import * as TypIcons from 'react-icons/ti'
import { Link, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router'
import authService from '../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2
} from '../../../Components/Main'
import ProfileDireita from '../../../Components/ProfileDireita'
import SidebarMobile from '../../../Components/SideBar-right/SidebarMobile'
import Modal from './modalTiposDeObservacoes/modalNovoSubGrupoDeQuestoes'
import ModalEditar from './modalTiposDeObservacoes/modalEditarSubGrupoDeQuestoes'
//import ModalEditar from '../'

function ChecklistSubGrupoQuestoes() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  //console.log(uuidv4);
  const [image, setImage] = useState('')
  var user = authService.getCurrentUser()
  var img = new Image()
  img.src = user[0].pesFoto
  // Se foi possível carregar a imagem
  img.onload = () => {
    setImage(user[0].pesFoto)
  }
  // Caso não seja possível
  img.onerror = () => {
    setImage('')
  }
  const [modal, setModal] = useState(false)
  const toggleModal = () => {
    setModal(!modal)
  }
  const [modalOpen, setModalOpen] = useState(false)
  const id = useParams<{ IdObservacaoGrupo: string }>()
  sessionStorage.IdObservacaoGrupoEdit = id.IdObservacaoGrupo
  let newDate = new Date()
  
  const [subGruposQuestoes, setSubGruposQuestoes] = useState<any[]>([])
  const [grupoQuestao, setGrupoQuestao] = useState<any[]>([])
  const [observacaoTipo, setObservacaoTipo] = useState<any[]>([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/observacaogrupo/' +
        id.IdObservacaoGrupo
      )
      .then(response => {
        setGrupoQuestao(response.data)

        axios
        .get(
            process.env.REACT_APP_API_URL +
            '/api/v1/observacaosubgrupo/list/' +
            id.IdObservacaoGrupo
        )
        .then(response2 => {
            setSubGruposQuestoes(response2.data)
        })

        axios
        .get(
            process.env.REACT_APP_API_URL +
            '/api/v1/observacaotipo/' +
            response.data[0].IdObservacaoTipo
        )
        .then(response => {
            setObservacaoTipo(response.data)
        })

      })

    
  }, [])

  
  useEffect(() => {
    
  }, [])

  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }

  const [modalInfo, setModalInfo] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [sidebar, setSidebar] = useState(false)
  const showSidebar = () => setSidebar(!sidebar)
  const history = useNavigate()
  const [toggle, setToggle] = useState(false)

  return (
    <div className="displayInteract">
      {modalOpen && (
        <ModalEditar setOpenModal={setModalOpen} modalInfo={modalInfo} />
      )}
      
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" style={{ width: '200px', height: '80px' }} />
        </div>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>
                {observacaoTipo[0]?.otpDescricao
                 + '/' + grupoQuestao[0]?.ogrDescricao
                 + '/ SUBGRUPO DE QUESTÕES'}
            </TitlePage1>
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fCxPesquisa"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <Link to={'/ChecklistQuestoes/0'}>
                <button className="btnPageGroupQuest">
                <span style={{ marginRight: '5px', fontWeight: 600, color: 'red' }} className='ti'>QUESTÕES SEM SubGrupo </span>
                <i className="fas fa-bars"></i>
                </button>
            </Link>
            <Modal />
          </div>
        </div>
        <div className="tabelaPadrao">
            <table>
              <thead>
                <th style={{ textAlign: 'center'}}>
                    Questões
                </th>
                <th style={{ textAlign: 'center'}}>
                    Editar
                </th>
                <th style={{ textAlign: 'center'}}>
                  Ordem
                </th>
                <th style={{ textAlign: 'left'}}>
                  Descrição
                </th>
                <th style={{ textAlign: 'center'}}>
                  Status
                </th>
              </thead>
              <tbody>
                {subGruposQuestoes
                  .filter((val) => {
                    if (searchTerm === '') {
                      return val
                    } else if (
                      val.sgrDescricao.toLowerCase().includes(searchTerm.toLowerCase())
                    ) {
                      return val
                    }
                  })
                  .map(subGrupoQuestao => (
                    <tr key={subGrupoQuestao.IdObservacaoSubGrupo}>
                        <td>
                            
                            <Link to={'/ChecklistQuestoes/' + subGrupoQuestao.IdObservacaoSubGrupo}>
                              <button className="btnPageGroupQuest">
                                <i className="fas fa-bars"></i>
                              </button>
                            </Link>
                        </td>
                        <td onClick={() => handleToggleComplete(subGrupoQuestao)}>
                            <button className="btnPageGroupQuest">
                            <i className="fas fa-edit"></i>
                            </button>
                        </td>
                        <td style={{ textAlign: 'center'}}>
                            {subGrupoQuestao.sbgNumero}
                        </td>
                        <td>
                            {subGrupoQuestao.sbgDescricao}
                        </td>
                        <td style={{ textAlign: 'center'}}>
                            <input
                            type="checkbox"
                            defaultChecked={!!subGrupoQuestao.sbgStatus}
                            disabled
                            />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
        </div>
      </ContainerPage>
      
      <button
        className="btnReturn"
        type="button"
        onClick={() => history(-1)}
      >
        <TypIcons.TiArrowBackOutline />
      </button>

      <nav className="esconderFiltro">
        <ProfileDireita />

        {user[0].gruDescricao === 'Humanit' || user[0].gruDescricao === 'Administrativo' || user[0].gruDescricao === 'Administrador' ? (
            <SidebarMobile />
        ) : (
            <div></div>
        )}
        </nav>
    </div>
  )
}

export default ChecklistSubGrupoQuestoes;
